import React from "react";
import { Box } from "@mui/material";
import { DotLegalHeader, DotLegalMultiSelect } from "@dotlegal/dotlegal-ui-components";
import DotLegalStepHeader from "../../../../common/components/dotLegalStepHeader/DotLegalStepHeader.tsx";
import { useTranslation } from "../../../../localization/useTranslation.ts";
import { SystemModel } from "../../../../system/systemEdit/SystemEdit.types.ts";
import { useSystemDataSubjectsField } from "./SystemDataSubjectsField.hooks.ts";

export interface SystemDataSubjectsFieldProps {
    systemId: string;
    system?: SystemModel;
    isLoading: boolean;
    isPreview: boolean;
    errorText?: string;
    disabled: boolean;
}

function SystemDataSubjectsField(props: SystemDataSubjectsFieldProps) {
    const { translateString } = useTranslation();
    const { isLoading, data, addDataSubject, removeDataSubject, systemDataSubjects, processingActivityDataSubjects } = useSystemDataSubjectsField({
        systemViewModel: props.system,
        systemId: props.systemId,
        isPreview: props.isPreview,
    });
    return (
        <Box sx={{ marginBottom: 3 }}>
            <DotLegalStepHeader record={false} topMargin>
                {translateString("chooseDataSubjectsForSystem")}
            </DotLegalStepHeader>

            <DotLegalMultiSelect
                disabled={props.isPreview || props.disabled}
                options={data?.filter((x) => processingActivityDataSubjects.indexOf(x.id) === -1)}
                isLoading={!props.isPreview && (isLoading || props.isLoading)}
                chosenOptions={systemDataSubjects}
                onChange={(v) => {
                    if (v?.length > systemDataSubjects.length) {
                        const addedId = v.find((x) => systemDataSubjects.indexOf(x) === -1);
                        addDataSubject(addedId!);
                    } else {
                        const removedId = systemDataSubjects.find((x) => v.indexOf(x) === -1);
                        removeDataSubject(removedId!);
                    }
                }}
                placeholder={translateString("dataSubjects")}
                label={translateString("dataSubjects")}
                noOptionsLabel={translateString("noOptions")}
            />

            {props.errorText && (
                <Box
                    sx={(theme) => ({
                        fontSize: theme.typography.pxToRem(12),
                        color: theme.palette.error.main,
                        textAlign: "center",
                        marginTop: theme.spacing(2),
                    })}
                >
                    {props.errorText}
                </Box>
            )}

            {processingActivityDataSubjects.length > 0 && (
                <>
                    <DotLegalStepHeader record={false} topMargin>
                        {translateString("dataSubjectsFromProcessingActivity")}
                    </DotLegalStepHeader>
                    <Box sx={{ display: "flex", justifyContent: "center" }}>
                        <DotLegalHeader headerStyle="small" fontWeight={300}>
                            {processingActivityDataSubjects
                                ?.map((x) => {
                                    return data?.find((s) => s.id === x)?.name ?? "";
                                })
                                .join(", ")}
                        </DotLegalHeader>
                    </Box>
                </>
            )}
        </Box>
    );
}

export default SystemDataSubjectsField;
